export enum RegimenLaboral {
  General = 0,
  Monotributo = 1,
  ServicioDomestico = 2
}

export enum TipoDocumento {
  DNI = 0,   // Documento Nacional de Identidad
  CI = 1,    // Cédula de Identidad
  LE = 2,    // Libreta de Enrolamiento
  LC = 3     // Libreta Cívica
}

export enum Sexo {
  Masculino = 0,
  Femenino = 1
}

export enum EstadoCivil {
  Soltero = 0,   // Soltero
  Casado = 1,    // Casado
  Divorciado = 2, // Divorciado
  Viudo = 3      // Viudo
}

export interface InscripcionOs {
    
  datosDelTitular: {
    regimenLaboral: RegimenLaboral;
    apellido: string;
    nombre: string;
    tipoDocumento: TipoDocumento;
    numeroDocumento: number;
    cuil: number;
    fechaNacimiento: Date;
    sexo: Sexo;
    nacionalidad: string;
    incapacidad: boolean;
    estadoCivil: EstadoCivil;
    telefono: number;
    celular: number;
    email: string;
    
    domicilio: {
      direccion: string;
      numero: number;
      piso: number;
      departamento: string;
      localidad: string;
      provincia: string;
      codigoPostal: string;
    };

    fechaIngresoEmpresa: Date;
    
  };

  datosDeLaEmpresa: {
    razonSocial: string;
    cuit: number;
    domicilio: string;
    telefono: number;
  };

  familiares: Familiar[];

}

export interface Familiar {
  parentesco: Parentesco;
  nacionalidad: Nacionalidad;
  incapacidad: boolean;
  nombre: string;
  apellido: string;
  fechaNacimiento: Date;
  sexo: Sexo;
  cuil: string;
  numeroDocumento: number;
  email?: string;
}

export enum Parentesco {
  Esposo = 0,
  Concubino = 1,
  Hijo = 2
}

export enum Nacionalidad {
  Argentino = 0,
  Extranjero = 1
}